export enum EReCaptchaType {
  Login = "addpointment_login",
  Register = "addpointment_register",
  RegisterTempUser = "addpointment_register_temporary_user",
  ForgotPassword = "addpointment_forgot_password",
}
